// extracted by mini-css-extract-plugin
export var alternate = "_m-h";
export var black = "_m-3";
export var blue = "_m-d";
export var blueLight = "_m-c";
export var brand = "_m-7";
export var error = "_m-9";
export var gray = "_m-6";
export var grayBlue = "_m-b";
export var iconWrapper = "_m-4";
export var indigo = "_m-e";
export var orange = "_m-g";
export var pink = "_m-f";
export var primary = "_m-0";
export var purple = "_m-8";
export var success = "_m-5";
export var warning = "_m-a";
export var white = "_m-1";
export var whiteSuccess = "_m-2";